'use client';

import { useState } from 'react';
import { type Dictionary } from '@/content/i18n/schema';

import styles from './IndividualPromo.module.scss';
import { Container } from '@/components/ui/Container/Container';
import { Section } from '@/components/ui/Section/Section';
import BrandTitle from '@/components/ui/BrandTitle/BrandTitle';
import StreamsRangeInput from '@/components/features/StreamsRangeInput/StreamsRangeInput';
import DMManagerButton from '@/components/ui/buttons/DMManagerButton/DMManagerButton';

interface IndividualPromoProps {
  dict: {
    promoInfo: Dictionary['promoInfo'];
    individualPromo: Dictionary['individualPromo'];
  };
}

export default function IndividualPromo({ dict }: IndividualPromoProps) {
  const { promoInfo, individualPromo } = dict;
  const [streams, setStreams] = useState(50);
  const costPerUnit =
    streams <= 100
      ? 25
      : streams <= 200
        ? 24
        : streams <= 300
          ? 23
          : streams <= 500
            ? 21
            : 20;
  const cost = streams * costPerUnit;

  return (
    <Section id="individual-promo" padding="xl">
      <Container size="xl">
        <BrandTitle
          className={styles.title}
          firstLine="Individual Promo"
          firstLineColor="orange"
        />
        <StreamsRangeInput
          min={1}
          max={1000}
          step={1}
          costPerUnit={costPerUnit}
          value={streams}
          onChange={setStreams}
          dictionary={individualPromo.streamsRange}
        />
        <div className={styles.ctaContent}>
          <p>{individualPromo.consultation.title}</p>
          <p>{individualPromo.consultation.description}</p>
          <DMManagerButton
            formCopy={promoInfo.form}
            isPersonalPlan={true}
            streams={streams}
            cost={cost}
          >
            {individualPromo.consultation.cta}
          </DMManagerButton>
        </div>
      </Container>
    </Section>
  );
}
